import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { setupListeners } from '@reduxjs/toolkit/query';
import uiReducer, { uiInitialState } from './uiSlice';
import customizerReducer, { customizerInitialState } from './customizerSlice';
import cartReducer, { cartInitialState } from './cartSlice';
import checkoutReducer, { checkoutInitialState } from './checkoutSlice';
import { APP_VERSION } from '../config/config';
import { apiSlice } from './apiSlice';

export const RESET_STORE = 'RESET_STORE';

const combinedReducer = combineReducers({
  ui: uiReducer,
  customizer: customizerReducer,
  cart: cartReducer,
  checkout: checkoutReducer,
  [apiSlice.reducerPath]: apiSlice.reducer
});

const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    state = {
      api: apiSlice,
      ui: uiInitialState,
      customizer: customizerInitialState,
      cart: cartInitialState,
      checkout: checkoutInitialState,
    };
  }

  return combinedReducer(state, action);
};

const persistConfig = {
  key: 'root',
  storage,
  version: APP_VERSION,
  whitelist: ['customizer', 'cart', 'checkout'],
  migrate: async (state) => {
    if (!state) return state;

    const lastUpdated = localStorage.getItem('lastUpdated') || 0;
    const now = Date.now();
    const CACHE_DURATION = 10 * 60 * 60 * 1000;

    if (now - lastUpdated > CACHE_DURATION) {
      localStorage.setItem('lastUpdated', now);
      return {
        ...state,
        _persist: {
          ...state._persist,
          version: APP_VERSION,
        },
        customizer: {
          ...customizerInitialState,
        },
        cart: {
          ...cartInitialState,
        },
        checkout: {
          ...checkoutInitialState,
        },
      };
    }

    return state;
  },
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(apiSlice.middleware),
});

export const persistor = persistStore(store);

setupListeners(store.dispatch);
